import {Injectable} from '@angular/core';
import {MessageService} from "primeng/api";
import {ErrorResponse} from "./error-response";

@Injectable({
    providedIn: 'root'
})
export class MessagingHandlerService {

    constructor(private messageService: MessageService) {
    }

    showSuccess(message: string, header?: string) {
        if (header) {
            this.messageService.add({severity: 'success', summary: header, detail: message});
        } else {
            this.messageService.add({severity: 'success', summary: 'Success', detail: message});
        }
    }

    showError(message: string, header?: string) {
        if (header) {
            this.messageService.add({severity: 'error', summary: header, detail: message});
        } else {
            this.messageService.add({severity: 'error', summary: 'Error', detail: message});
        }
    }

    showHttpError(httpError: any, altErrorMessage: string, header?: string, ttl?: number) {
        let headerToShow = (header) ? header : 'Error';

        if (httpError && httpError.error) {
            let error: ErrorResponse = httpError.error.error as ErrorResponse;
            if (error && error.message) {
                let messageToShow = altErrorMessage;
                if (error.sanitized) {
                    messageToShow += ": " + error.message;
                }

                if (ttl) {
                    this.messageService.add({severity: 'error', summary: headerToShow, detail: messageToShow, life: ttl});
                } else {
                    this.messageService.add({severity: 'error', summary: headerToShow, detail: messageToShow});
                }
                return;
            } else {
                error = httpError.error as ErrorResponse;
                if (error && error.message) {
                    let messageToShow = altErrorMessage;
                    if (error.sanitized) {
                        messageToShow += ": " + error.message;
                    }

                    if (ttl) {
                        this.messageService.add({severity: 'error', summary: headerToShow, detail: messageToShow, life: ttl});
                    } else {
                        this.messageService.add({severity: 'error', summary: headerToShow, detail: messageToShow});
                    }
                    return;
                }
            }
        }

        if (ttl) {
            this.messageService.add({severity: 'error', summary: headerToShow, detail: altErrorMessage, life: ttl});
        } else {
            this.messageService.add({severity: 'error', summary: headerToShow, detail: altErrorMessage});
        }
    }
}
